import { Button as AntdButton, ButtonProps } from 'antd';
import { FC } from 'react';

const Button: FC<ButtonProps> = (props) => {
  return <AntdButton {...props} />;
};

export default Button;
